module.exports = __webpack_public_path__ + "img/world.23fab423.svg";